







































import { editFactory } from '@/main/pages/editFactory';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { NAME } from './constants';
import { store } from './store/edit';
import { editMutationsNames } from './store/constants';

export default editFactory(NAME, store).extend({
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${editMutationsNames.NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		naklStredFilter() {
			return { ProvozovnaId: this.ProvozovnaId };
		},
	},
});
